import React from "react";
import { Link } from "gatsby";
import classNames from "classnames";
import pp_logo from "../../images/header/ppl.svg";
import HamburgerMenuIcon from "../../images/header/hamburger-menu.svg";
import "./Header.css";

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.headerRef = React.createRef();
        this.state = {
            showMobPanel: false,
        };
    }

    componentDidMount() {
        if (typeof window !== "undefined") {
            window.addEventListener("scroll", this.handleScroll);
        }
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }

    handleMobileNavbarPanel = e => {
        this.setState({ showMobPanel: !this.state.showMobPanel });
    };

    handleScroll = () => {
        let scroll = window.scrollY;
        if (scroll > 20) {
            this.headerRef.current.classList.add("drop-shadow");
        } else {
            this.headerRef.current.classList.remove("drop-shadow");
        }
    };

    isPartiallyActive = ({ isPartiallyCurrent }) => {
        return isPartiallyCurrent ? { className: "active" } : {};
    };

    render() {
        const { showMobPanel } = this.state;
        return (
            <>
                <div className="header-container" ref={this.headerRef}>
                    <header>
                        <div className="logo">
                            <Link to="/">
                                <img src={pp_logo} alt="PhonePe Logo" />
                            </Link>
                        </div>
                        <div className="navigation-links">
                            <div className="logo mobile-logo">
                                <Link to="/">
                                    <img src={pp_logo} alt="phonepe logo" />
                                </Link>
                            </div>
                            <Link to="/" activeClassName="active">
                                Home
                            </Link>
                            <Link
                                to="/business-solutions/"
                                activeClassName="active"
                                getProps={this.isPartiallyActive}
                            >
                                Business Solutions
                            </Link>
                            <Link
                                to="/press/"
                                activeClassName="active"
                                getProps={this.isPartiallyActive}
                            >
                                Press
                            </Link>

                            <Link
                                to="/careers/"
                                activeClassName="active"
                                getProps={this.isPartiallyActive}
                            >
                                Careers
                            </Link>

                            <Link
                                to="/about-us/"
                                activeClassName="active"
                                getProps={this.isPartiallyActive}
                            >
                                About Us
                            </Link>
                            <a href="https://blog.phonepe.com/" target="_blank">
                                Blog
                            </a>
                            <Link
                                to="/contact-us/"
                                activeClassName="active"
                                getProps={this.isPartiallyActive}
                            >
                                Contact Us
                            </Link>
                        </div>
                        <span
                            className="pp-hamburger-icon"
                            onClick={this.handleMobileNavbarPanel}
                        >
                            <img src={HamburgerMenuIcon} alt="hamburger menu" />
                        </span>
                    </header>
                </div>
                <div
                    className={classNames("mobile-navigation", {
                        "mobile-navigation-hide": !showMobPanel,
                    })}
                >
                    <div
                        className={classNames("mobile-overlay", {
                            "mobile-navigation__overlay": showMobPanel,
                        })}
                        onClick={this.handleMobileNavbarPanel}
                    ></div>
                    <div
                        className={classNames("mobile-navigation__sidepanel", {
                            "show-mobile-nav": showMobPanel,
                        })}
                    >
                        <div
                            className="mobile-navigation__sidepanel__close"
                            onClick={this.handleMobileNavbarPanel}
                        >
                            &#10005;
                        </div>
                        <Link to="/" activeClassName="active">
                            Home
                        </Link>
                        <Link
                            to="/business-solutions/"
                            activeClassName="active"
                            getProps={this.isPartiallyActive}
                        >
                            Business Solutions
                        </Link>
                        <Link
                            to="/press/"
                            activeClassName="active"
                            getProps={this.isPartiallyActive}
                        >
                            Press
                        </Link>

                        <Link
                            to="/careers/"
                            activeClassName="active"
                            getProps={this.isPartiallyActive}
                        >
                            Careers
                        </Link>
                        <Link
                            to="/about-us/"
                            activeClassName="active"
                            getProps={this.isPartiallyActive}
                        >
                            About Us
                        </Link>
                        <a href="https://blog.phonepe.com/" target="_blank">
                            Blog
                        </a>
                        <Link
                            to="/contact-us/"
                            activeClassName="active"
                            getProps={this.isPartiallyActive}
                        >
                            Contact Us
                        </Link>
                    </div>
                </div>
            </>
        );
    }
}

export default Header;
